import axios from 'axios'
import { Notification } from 'element-ui'

// const efUploadURL = 'https://img.exporegist.com/serv/api/Base64Image/Upload'
// const serverURI = 'https://serv.exporegist.com/SelfNewApi/api/v1.0'
// const serverURI = 'https://cac.exporegist.com/selfSerapi/api/v1.0'
// const serverURI = 'https://newcrm.cacshow.com/selfSerapi/api/v1.0'
// const serverURI = 'https://c.m-scci.com/selfSerapi/api/v1.0'
// const serverURI = 'https://cactest.exporegist.com/SelfSerTestApi'
const serverURI = sessionStorage.getItem('baseUrl')
// console.log(serverURI,'serverURI')
// const serverURI = 'https://api.exporeg.cn/SelfSerApi/api/v1.0'
// const serverURI = 'http://192.168.173.70/SelfNewApi/api/v1.0'
// const serverURI = 'https://serv.exporegist.com/selfapitest/api/v1.0'
// const exhId = window.location.href.split('ExhID=')[1].split('&')[0]
var axios1 = axios.create()
export default {
  init(router: any) {
    axios1.defaults.baseURL = serverURI? serverURI.toString() : 'https://c.m-scci.com/selfSerapi/api/v1.0'
    axios1.interceptors.request.use(
      (request) => {
        request.headers.token = localStorage.getItem('token') || ''
        request.data = request.data || {}
        request.data.exhId = request.data.exhId || localStorage.getItem('ExhID') || localStorage.getItem('exhidfixed')
        // console.log(request.data.exhId,'exhid')
        if(request.data.exhId === 'null' || request.data.exhId === null || request.data.exhId === ''){
          request.data.exhId = localStorage.getItem('exhidfixed')
          router.push('/login?ExhID='+localStorage.getItem('exhidfixed'))
          // console.log(request.data.exhId,'exhid1')
        }
        return request
      },
      (error) => {
        throw error
      }
    )
    axios1.interceptors.response.use(
      (response) => {
        if (response.data.code === 900 || response.data.code === 100 || response.data.code === 101) {
          // router.push('/login?ExhID='+localStorage.getItem('ExhID'))
          router.push('/login?ExhID='+localStorage.getItem('exhidfixed'))
          localStorage.removeItem('userInfo')
          localStorage.removeItem('token')
        }
        // console.log(response.config.url.indexOf('pullcatalog')>-1,'qqqqqqqqqqqqqqq')
        // && response.config.url.indexOf('pullcatalog') == -1
        if (response.data.code !== 200 && response.data.msg) {
          if(response.data.msg !== 'failure') { 
            Notification.error({
              title: response.data.msg,
              message: ''
            })
          }
        }
        return response
      },
      (error) => {
        throw error
      }
    )
    // this.setHeader()

    axios.interceptors.request.use(
      (request) => {
        request.data = request.data || {}
        request.data.exhId = localStorage.getItem('ExhID') || localStorage.getItem('exhidfixed')
        return request
      },
      (error) => {
        throw error
      }
    )
    // axios.interceptors.response.use(
    //   (response) => {
    //     if (response.data.code === 900) {
    //       router.push('/login?ExhID='+localStorage.getItem('ExhID'))
    //       localStorage.removeItem('userInfo')
    //       localStorage.removeItem('token')
    //     }
    //     if (response.data.code !== 200 && response.data.msg) {
    //       Notification.error({
    //         title: response.data.msg,
    //         message: ''
    //       })
    //     }
    //     return response
    //   },
    //   (error) => {
    //     throw error
    //   }
    // )
  },
  // setHeader() {
  //   axios.defaults.headers.common = {
  //     token: localStorage.getItem('token')
  //   }
  // },
  getselfbasicfield(data: any) {
    return axios1.post(`${serverURI}/common/getselfbasicfield`, data)
  },
  getlicensecode(data: any) {
    return axios1.post(`${serverURI}/actor/getlicensecode`, data)
  },
  login(data: any) {
    return axios1.post(`${serverURI}/login/login`, data)
  },

  logout() {
    return axios1.post(`${serverURI}/logout`)
  },
  // 获取展会基础信息
  getexhinfo(data: any) {
    return axios1.post(`${serverURI}/template/getexhinfo`, data)
  },
  // 获取首页表格列表
  getformsetting(data: any) {
    return axios1.post(`${serverURI}/template/getformsetting`, data)
  },
  // 上传图片
  uploadImg(data: any) {
    return axios1.post(`${serverURI}/common/uploadimage`, data)
  },
  // 上传图片不需要token
  uploadimage1(data: any) {
    return axios1.post(`${serverURI}/common/uploadimage1`, data)
  },
  // 会刊 主营产品
  getexhibitstype(data: any) {
    return axios1.post(`${serverURI}/common/getexhibitstype`, data)
  },
  // 会刊 获取会刊详情
  getcatalogdetail(data: any) {
    return axios1.post(`${serverURI}/catalog/getcatalogdetail`, data)
  },  
  pullcatalog(data: any) {
    return axios1.post(`${serverURI}/catalog/pullcatalog`, data)
  },
  // 会刊保存
  savecatalog(data: any){
    // return axios1.post(`${serverURI}/catalog/savecatalog`, data)
    return axios1.post(`${serverURI}/catalog/SaveCACCatalog`, data)
  },
  // 公司类别
  getcompanytype(data: any) {
    return axios1.post(`${serverURI}/common/getcompanytype`, data)
  },
  //获取国家
  getallcountrys(data: any) {
    return axios1.post(`${serverURI}/common/getallzhcountrys`, data)
  },
  //获取省份
  getallprovinces(data: any) {
    return axios1.post(`${serverURI}/common/getallprovinces`, data)
  },
  //获取城市
  getallcitysbyprovince(data: any) {
    return axios1.post(`${serverURI}/common/getallcitysbyprovince`, data)
  },
  
  getallxiansbycity(data: any) {
    return axios1.post(`${serverURI}/common/getallxiansbycity`, data)
  },
  // 证件列表
  ticketlist(data: any) {
    return axios1.post(`${serverURI}/ticket/ticketlist`, data)
  },
  // 新增证件
  addticket(data: any) {
    // return axios1.post(`${serverURI}/ticket/addticket`, data)
    return axios1.post(`${serverURI}/ticket/AddCACTicket`, data)
  },
  // 证件详情
  getticketdetails(data: any) {
    return axios1.post(`${serverURI}/ticket/getticketdetails`, data)
  },
  // 修改证件
  updateticket(data: any) {
    return axios1.post(`${serverURI}/ticket/UpdateCACTicket`, data)
    // return axios1.post(`${serverURI}/ticket/updateticket`, data)
  },
  // 删除证件
  deleteticket(data: any) {
    return axios1.post(`${serverURI}/ticket/deleteticket`, data)
  },
  // 获取楣板信息
  getlinteldetail(data: any) {
    return axios1.post(`${serverURI}/catalog/getlinteldetail`, data)
  },
  // 修改保存楣板信息
  savelintel(data: any) {
    return axios1.post(`${serverURI}/catalog/savelintel`, data)
  },
  // 获取预定服务列表
  getservicebooklist(data: any) {
    return axios1.post(`${serverURI}/servicebook/getservicebooklist`, data)
  },
  // 保存服务预定
  saveservicebook(data: any) {
    return axios1.post(`${serverURI}/servicebook/saveservicebook`, data)
  },
  // 展品列表
  productlist(data: any) {
    return axios1.post(`${serverURI}/product/productlist`, data)
  },
  // 展品详情
  // productinfo(data: any) {
  //   return axios.post(`${serverURI}/product/productinfo`, data)
  // },
  // 展品详情
  productinfo(data: any) {
    return axios1.post(`${serverURI}/product/productdetail`, data)
  },
  // 查询产品分类
  searchproducttype(data: any) {
    return axios1.post(`${serverURI}/product/searchproducttype`, data)
  },
  // 查询产品分类
  gettypeinfonotoken(data: any) {
    return axios1.post(`${serverURI}/product/gettypeinfonotoken`, data)
  },
  // 新增/修改展品
  saveproduct(data: any) {
    return axios1.post(`${serverURI}/product/saveproduct`, data)
  },
  //删除展品
  deleteproduct(data: any) {
    return axios1.post(`${serverURI}/product/deleteproduct`, data)
  },
  //获取展商基本信息
  getactordetails(data: any) {
    return axios1.post(`${serverURI}/actor/getactordetails`, data)
  },
  //更新展商基本信息
  updateactor(data: any) {
    return axios1.post(`${serverURI}/actor/updateactor`, data)
  },
  //修改密码
  updateactorpwd(data: any) {
    return axios1.post(`${serverURI}/actor/updateactorpwd`, data)
  },
  //获取活动详情
  getactivitydetail(data: any) {
    return axios1.post(`${serverURI}/activity/getactivitydetail`, data)
  },
  //获取活动列表
  getactivitys(data: any) {
    return axios1.post(`${serverURI}/activity/getactivitys`, data)
  },
  //获取活动列表
  gethostactivitys(data: any) {
    return axios1.post(`${serverURI}/activity/gethostactivitys`, data)
  },
  //删除活动
  deleteactivity(data: any) {
    return axios1.post(`${serverURI}/activity/deleteactivity`, data)
  },
  //活动 新增/修改活动
  saveactivity(data: any) {
    return axios1.post(`${serverURI}/activity/saveactivity`, data)
  },
  // 搭建商邀请码
  getexhbuildinvitecode(data: any) {
    return axios1.post(`${serverURI}/actor/getexhbuildinvitecode`, data)
  },
  // 获取自服务报名信息项
  getregisterconfig(data: any) {
    return axios1.post(`${serverURI}/actor/getregisterconfig`, data)
    // return axios.post(` http://123.57.238.19/SelfApi/api/v1.0/common/getregisterconfig`, data)
  },
  // 展商提交报名信息
  saveactorapply(data: any) {
    return axios1.post(`${serverURI}/actor/saveactorapply`, data)
  },
  // 展商注册
  addactorapply(data: any) {
    return axios1.post(`${serverURI}/actor/addactorapply`, data)
  },
  // 获取表单配置项
  getsaasfield(data: any) {
    return axios1.post(`${serverURI}/common/getsaasfield`, data)
  },
  // 获取菜单配置
  getmenulist(data: any) {
    return axios1.post(`${serverURI}/common/getmenulist`, data)
  },
  // 获取是否开启实名验证配置
  checkisrealname(data: any) {
    return axios1.post(`${serverURI}/common/checkisrealname`, data)
  },
  // 获取证件数量
  getticketnum(data: any) {
    return axios1.post(`${serverURI}/ticket/getticketnum`, data)
  },
  // 验证Token获取接口
  GetValidationToken(data: any) {
    // return fetch('https://yzt.exporegist.com/actor/api/IdentityCheck/GetValidationToken', data);
    return axios.post('https://std.eastfair.com/IdCardAuthon/api/IdentityCheck/GetValidationToken', data);
  },
  // 验证身份证的真实性
  CheckValidation(data: any) {
    // return fetch('https://yzt.exporegist.com/actor/api/IdentityCheck/CheckValidationv2', data);
    return axios.post('https://std.eastfair.com/IdCardAuthon/api/IdentityCheck/CheckValidationv2', data);
  },
  // 人脸识别
  FaceDetect(data: any) {
    // return fetch('https://yzt.exporegist.com/actor/api/IdentityCheck/CheckValidationv2', data);
    return axios.post('https://std.eastfair.com/Faceai/api/Face/FaceDetect', data);
  },
  //生成邀请函
  generateinvitationletters(data: any) {
    return axios1.post(`${serverURI}/actor/generateinvitationletters`, data)
  },
  // 获取展品中英文名称
  GetPdtInfoDetail(data: any){
    return axios1.post(`${serverURI}/product/GetPdtInfoDetail`, data)
  },
  getProductTypeDetail(data: any) {
    return axios1.post(`${serverURI}/product/GetProductTypeDetail`, data)
  },
  saveProductType(data: any) {
    return axios1.post(`${serverURI}/product/SaveProductType`, data)
  },
  ticketnotthelist(data: any) {
    return axios1.post(`${serverURI}/ticket/ticketnotthelist`, data)
  },
  // 证件列表页-保存
  SaveCACTicketSubmitStatus(data: any) {
    return axios1.post(`${serverURI}/ticket/SaveCACTicketSubmitStatus`, data)
  },
  addtickets(data: any) {
    return axios1.post(`${serverURI}/ticket/addtickets`, data)
  },
  getdynamicboothmapurl(data: any) {
    return axios1.post(`${serverURI}/actor/getdynamicboothmapurl`, data)
  },
  getexhibitionlist(data: any) {
    return axios1.post(`${serverURI}/actor/getexhibitionlist`, data)
  }
  // // 证件姓名查找
  // ticketnotthelist(param) {
    //   return api({
    //     url: `${serverURI}//ticketnotthelist`,
    //     method: 'post',
    //     data: param
    //   })
    // },
  // 批量新增证件
  // addtickets(param) {
    // return api({
    // url: `${serverURI}/ticket/addtickets`,
    // method: 'post',
    // data: param
    // })
    // },
}
